<template>
  <kst-table action input-mode :data="userItems">
    <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
      <template #header>
        <kst-header-blank />
      </template>
      <template #default="{ row }">
        <kst-tooltip v-if="row.Errors.length > 0" error-mode>
          <template #content>
            <kst-list :items="row.Errors"/>
          </template>
          <kst-icon error-mode/>
        </kst-tooltip>
      </template>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="k-control-py"
      field="DispatchID"
      :label="HppAdjItemCatalog.DispatchID.ColumnLabel"
    >
      <kst-value error-off field-only
        class="k-control-py"
        :field="column.field" :data="row" :catalog="HppAdjItemCatalog"
      />
    </b-table-column>

    <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
      <template #header>
        <kst-header-blank />
      </template>
      <template #default="{ row }">
        <kst-tooltip info-mode>
          <template #content>
            <kst-list info-mode :items="Model.New.getItemInfo(row)"/>
          </template>
          <kst-icon info-mode/>
        </kst-tooltip>
      </template>
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      field="Stock"
      :label="HppAdjItemCatalog.Stock.Label"
    >
      <kst-value error-off field-only
        class="k-control-py"
        :field="column.field" :data="row" :catalog="HppAdjItemCatalog"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      field="HppPerPcs"
      :label="HppAdjItemCatalog.HppPerPcs.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="HppAdjItemCatalog"
        :index="index" @error="handleRowErrors" @input="handleHppPerPcs(row)"
      />
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      field="HppTotal"
      :label="HppAdjItemCatalog.HppTotal.Label"
    >
      <kst-output box-off field-only
        :field="column.field" :data="row" :catalog="HppAdjItemCatalog"
      />
    </b-table-column>

    <template #action="{ index }">
      <kst-tooltip delete-mode hover-only :content="Model.HppAdjItem.Module.FullName">
        <kst-button delete-mode is-round @click="handleRowDelete(index)"/>
      </kst-tooltip>
    </template>

    <template #empty-body>
      <ValidationProvider v-slot="{ errors }" name="userItems" rules="required">
        <kst-error :array-blank-mode="!!errors"/>
      </ValidationProvider>
    </template>
  </kst-table>
</template>

<script>
import DialogMixin from "../../../mixins/DialogMixin.js";
import Info from "../HpadInfo.js";
import Model from "../HpadModel.js";
import HppAdjItemCatalog from "../HpadItemCatalog.js";

export default {
  mixins: [DialogMixin],
  props: {
    userItems: Array
  },
  data: () => ({
    Model: Model,
    HppAdjItemCatalog: HppAdjItemCatalog
  }),
  methods: {
    handleHppPerPcs(item) {
      Model.updateItem(item);
    },

    handleRowDelete(index) {
      this.showConfirm(
        Info.Message.New_ConfirmDeleteItem,
        this.handleRowDelete_confirm,
        null,
        index
      );
    },
    handleRowDelete_confirm(index) {
      this.userItems.splice(index, 1);
    },

    handleRowErrors(errors, field, index) {
      Model.setItemErrors(this.userItems[index], field, errors);
    }
  }
}
</script>